<template>
<div class="pedidoCard">
    <el-card
      :class="{ not_selected: esPedidoSubagente && !pedido.Seleccionado, selectable: esPedidoSubagente && pedido.Instancia == '1G'}"
      @click.native="selectPedido">
      <!-- ícono check -->
      <div class="iconContainer2 checkContainer" v-if="esPedidoSubagente && pedido.Seleccionado">
        <i class="el-icon-check"></i>
      </div>

      
        <div class="cardBody">
         
          <el-row>
            <el-col :span="2">
            <div :class="opened ? 'triangleDown' : 'triangleRight'" v-on:click="toggleOpen"></div>
            </el-col>
            <el-col :span="18">
              <div class="nroPedido">{{$t('PEDIDO_numero_pedido')}}: {{pedido.Numero}}</div>
            </el-col>
            <el-col :span="4" class="contenedorIconos">
              <div class='iconContainer' @click="editar" v-show="sinConfirmar" >
                <el-tooltip class="item" effect="dark" :content="$t('GENERAL_editBtn')" placement="left">
                  <i class="el-icon-edit"></i>
                </el-tooltip>
              </div>
              <div class='iconContainer' @click="detalle">
                <el-tooltip class="item" effect="dark" :content="$t('PEDIDO_detalles')" placement="right">
                  <i class="el-icon-tickets"></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>

          <el-row>
              <el-col :span="10" class="label blackLabel">{{$t('GENERAL_fecha')}}:</el-col>
              <el-col :span="10" class="greyLabel">{{pedido.FechaStr}}</el-col>
              
              <el-col :span="4" class="contenedorIconos">
                <div class="iconContainer" @click="descargarReporte('pdf')">
                    <el-tooltip class="item" :content="$t('PEDIDO_descargar_reporte_pdf')" effect="dark" placement="left">
                    <i class="el-icon-download" v-if="!estaDescargando_pdf"></i>
                    <i v-else class="el-icon-loading primary"></i>
                </el-tooltip>
                </div>
                <div class="iconContainer iconDelete" v-show="sinConfirmar" @click="eliminar">
                  <el-tooltip class="item" effect="dark" :content="$t('GENERAL_deleteBtn')" placement="right">
                      <i class="el-icon-delete"></i>
                  </el-tooltip>
                </div>
              </el-col>
          </el-row>

          <el-row v-if="pantallaOrigen == 'PedidoSubagente'">
            <el-col :span="10" class="label blackLabel">{{$t('PEDIDOSUBAGENTE_cliente')}}:</el-col>
              <el-col :span="10" class="greyLabel">{{pedido.Empresa}}</el-col>
          </el-row>

          <el-row v-if="(pantallaOrigen == 'PedidoADistribuidor' && !verPrecios) || pantallaOrigen == 'PedidoSubagente'">
                <!--
                <div v-if="esPedidoSubagenteSeleccionado" class="iconContainer" style="text-align: right" >
                      <el-tooltip class="item" :content="$t('PEDIDO_descargar_reporte_excel')" effect="dark" placement="right">
                      <i class="el-icon-notebook-2" v-if="!estaDescargando_excel" @click="descargarReporteSubagente()"></i>
                      <i v-else class="el-icon-loading primary"></i>
                  </el-tooltip>
                  </div>
                -->
                  <div></div>
          </el-row>
          <el-row v-else>
              <el-col :span="10" class="label blackLabel">{{$t('PEDIDO_importe_final')}}:</el-col>
                <el-col :span="10" class="greyLabel">{{ decimalToString(pedido.ImporteTotal) }}</el-col>
          
                <el-col :span="4" class="contenedorIconos">
                  <div class="iconContainer" @click="descargarReporte('xlsx')">
                      <el-tooltip class="item" :content="$t('PEDIDO_descargar_reporte_excel')" effect="dark" placement="right">
                      <i class="el-icon-notebook-2" v-if="!estaDescargando_excel"></i>
                      <i v-else class="el-icon-loading primary"></i>
                  </el-tooltip>
                  </div>
                </el-col>
          </el-row>


          <transition name="fade">
            <div v-show="opened">
              <el-row>
                  <el-col :span="12" class="label blackLabel">{{$t('PEDIDO_instancia')}}:</el-col>
                  <el-col :span="12" class="greyLabel">{{descripcionInstancia}}</el-col>
              </el-row>
            </div>    
          </transition>
        </div>
      </el-card>
  </div>
</template>

<script>
import { decimalToString } from '../Helpers/commonFunctions'
import i18n from "../../plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "pedidoCard",
  props: {
    pedido: Object,
    pantallaOrigen: String,
    verPrecios: { type: Boolean, default: true }
    },
  data() {
    return {
      activeNames: ["1"],
      loading: false,
      opened: false,
      sinConfirmar: false,
      descargando_pdf: false,
      descargando_excel: false,
      visible_tooltip:false,
      esPedidoSubagente: false,
      esPedidoSubagenteSeleccionado: false,
    };
  },

  methods: 
  {
    decimalToString: decimalToString,

    selectPedido(event) {
        event.stopPropagation();
        this.pedido.Seleccionado = !this.pedido.Seleccionado;
        this.$emit("selectPedido", this.pedido.Id);
    },

    toggleOpen(event) {
      event.stopPropagation();
      this.opened = !this.opened     
    },
    editar() {
      this.$emit('editar', this.pedido.Id)
    },
    detalle() { 
      this.$emit('detalle', this.pedido.Id)
    },
    eliminar(){
      this.$emit('eliminar', this.pedido.Id)
    },
    pedidoInstancia(){
      //Se agrega la instancia de Ingreso de Pedidos a Distribuidor
      if(this.pedido.Instancia == "0A" || this.pedido.Instancia == "1A" || this.pedido.Instancia == "0G"){
            this.sinConfirmar = true
          }
        
    },
    descargarReporte(extension){
      event.stopPropagation();
      
      let idioma = i18n.locale;
      if (extension === 'pdf'){
        this.descargando_pdf = true;

        if(this.pantallaOrigen == "PedidoSubagente" || this.pantallaOrigen == "PedidoADistribuidor"){
            this.$store.dispatch("pedidosSubagentes/descargarPedido", { idPedido: this.pedido.Id, idUsuario: this.idUsuario, idioma: idioma, extension: extension, pantallaOrigen: this.pantallaOrigen })
          .then(response =>
          {
            let link = document.createElement('a')
            link.href = "data:application/pdf" + ";base64," + encodeURIComponent(response.Datos)
            link.target = '_blank';
            link.setAttribute('download', this.$t('PEDIDO_pedido') +"_" + this.pedido.Numero);
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
          .finally(() => this.descargando_pdf = false);
        }else{
            this.$store.dispatch("pedidos/descargarPedido", { idPedido: this.pedido.Id, idUsuario: this.idUsuario, idioma: idioma, extension: extension})
          .then(response =>
          {
            let link = document.createElement('a')
            link.href = "data:application/pdf" + ";base64," + encodeURIComponent(response.Datos)
            link.target = '_blank';
            link.setAttribute('download', this.$t('PEDIDO_pedido') +"_" + this.pedido.Numero);
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
          .finally(() => this.descargando_pdf = false);
        }
        
      }
      else{
        this.descargando_excel = true;
        this.$store.dispatch("pedidos/descargarPedido", { idPedido: this.pedido.Id, idUsuario: this.idUsuario, idioma: idioma, extension: extension })
        .then(response =>
        {
          let link = document.createElement('a')
          link.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" + ";base64," + encodeURIComponent(response.Datos)
          link.target = '_blank';
          console.log(link.href);
          link.setAttribute('download', this.$t('PEDIDO_pedido') +"_" + this.pedido.Numero + ".xlsx");
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => this.descargando_excel = false);
      }
    },
    show_tooltip() {
      this.visible_tooltip = true
    },
    hide_tooltip() {
      this.visible_tooltip = false
    }
  },
  mounted() {
    this.pedidoInstancia();
    if(this.pantallaOrigen == 'PedidoSubagente'){
      this.esPedidoSubagente = true;
    }
    if(this.pantallaOrigen == 'PedidoSubagente' && this.pedido.Instancia == "2G"){
      this.esPedidoSubagenteSeleccionado = true;
    }
  },
  computed: {
    ...mapState({
    idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
    }),
    descripcionInstancia() {
        let descripcion = ''
        
        switch(this.pedido.Instancia)
        {
          case '0A': case '1A':
            descripcion = this.$t('PEDIDO_instancia_sin_confirmar')
            break

          case 'A': case 'AE': case 'B': case 'B1': case 'B2': case 'C': case 'D': case 'E': case 'P': case 'R':
            descripcion = this.$t('PEDIDO_instancia_proceso')
            break

          case 'X': case 'Z': case 'ZG':
            descripcion = this.$t('PEDIDO_instancia_historico')
            break

          case '2A': case '1G':
            descripcion = this.$t('PEDIDO_instancia_confirmado')
            break

          case '0G':
            descripcion = this.$t('PEDIDOADISTRIBUIDORES_instancia_ingreso')
            break
            
          case '2G':
            descripcion = this.$t('PEDIDOSUBAGENTE_instancia_seleccionado')
            break

          default:
            descripcion = ''
        }

        return `(${this.pedido.Instancia}) ${descripcion}`
      },
    estaDescargando_pdf()
      {
        return this.descargando_pdf;
      },
    estaDescargando_excel()
      {
        return this.descargando_excel;
      },
  }
}
</script>

<style>
.el-card__body {
  min-height: 42px;
}
</style>

<style scoped>
.selectable {
  cursor: pointer;
}

.not_selected {
  border-top: 0px !important;
}

.iconContainer2 {
  cursor: pointer;
  font-size: 19px;
}

.iconContainer2.checkContainer {
  position: absolute;
  top: -12.5px;
  right: -1px;
  background-color: var(--main-color);
  border-radius: 20px;
  width: 30px;
  height: 30px;
  color: white;
}

.iconContainer2.checkContainer > .el-icon-check {
  padding: 5px;
}

.triangleRight,
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  cursor: pointer;
}
.triangleRight {
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
}
.triangleDown {
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
}

.verDetalles {
  color:var(--main-color);
  text-align: right;
  font-size: 13px ;
  font-weight: normal;
}

.greyLabel {
  color: #6B6B6B;
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}

.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;
  
}

.nroPedido{
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 5px;
}

.seleccionador {
    width: 100%;
    padding: 0;
}

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}

.iconContainer {
  cursor: pointer;
  font-size: 19px;
  margin-left: 4px;
}

.iconDelete{
  text-align: right;
}

.contenedorIconos {
  display: flex;
  justify-content: flex-end;
}



@media (max-width: 600px) {
  .cardBody {
    flex-direction: column;
  }
}

.card_list_item {
  position: relative;
}
.pedidoCard {
  width: 100%;
}

</style>
